const DEFAULT_STATE = {
  list: []
};

export default function reducer (state = DEFAULT_STATE, {type, payload}) {
  switch (type){
    case 'SET_BLOCK_LIST_EMAILS':
      return { ...state, list: payload };
    default:
      return state;
  };
}
